import React from 'react';
import qs from 'query-string';
import classNames from 'classnames';
import cat1 from '../../images/cat1@3x.jpg';
import cat2 from '../../images/cat2@3x.jpg';
import cat3 from '../../images/cat3@3x.jpg';
import './styles.scss';


const CategoryNavigationItems = props => {

    if (!props.categories) return null;

    const generateQuery = (facets) => {
        const queryObj = [];
        facets.forEach(facet => {
          queryObj.push(qs.stringify({
            typename: facet.label
          }));
        });
  
        return queryObj.join('&');
        //console.log(qs.stringify(queryObj));
      };

    const Content = category => {
        return (
            <>
                <div className="category-navigation__image-container">
                    <img className="category-navigation__item-image" src={getIcon(category.label)} alt="" />
                </div>
                <h2 className="category-navigation__heading">{category.label}</h2>
                <span className="category-navigation__text">{getByline(category.label)}</span>                
            </>
        );
    }

    const getIcon = (category) => {
        switch (category) {
            case 'Foodservice': 
                return cat3;
            case 'Servicehandel':
                return cat2;
            default:
                return cat1;
        }
    };

    const getByline = (category) => {
        switch (category) {
            case 'Foodservice': 
                return 'Enheter fördelade på segment inom Sveriges storkök - både privat och offentlig sektor. ';
            case 'Servicehandel':
                return 'Enheter fördelade på olika segment som: kiosk, tobak, cafe/konditori och många fler.';
            case 'Livs':
                return 'Livsmedelsbutiker fördelade på segment som: stormarknad, varuhus, servicebutik med flera. ';
            case 'Hälsa & Egenvård':
                return 'Enheter fördelade på segment som apotek, gym och hälsokost. ';
            case 'Grossister':
                return 'Grossister fördelade på segment som huvudkontor, distributionslager och snabbgrossist.';
            default:
                return '';
        }
    };

    const hasAccessCategories = props.categories.facets[0].facetValues.filter(cat => cat.count > 0);
    const hasNoAccessCategories = props.categories.facets[0].facetValues.filter(cat => cat.count === 0);
    const categories = [...hasAccessCategories, ...hasNoAccessCategories];

    return (
        <>
            {categories.map(category => {
                if (category.count > 0) {
                    return (
                        <a href={`/search?typegroupname=${category.label}&${generateQuery(category.childrenFacetValues)}`} className="category-navigation__item" key={`category${category.code}`}>
                            <div className="category-navigation__content">
                                <Content {...category} />
                                <span className="category-navigation__num">{category.count.toLocaleString('sv')} enheter</span>
                            </div>
                        </a>
                    );
                } else {
                    return (
                        <span className="category-navigation__item category-navigation__item--no-access" key={`category${category.code}`}>
                            <div className="category-navigation__content">
                                <Content {...category} />
                            </div>
                            <a href="mailto:info@delfi.se" className="category-navigation__access">Kontakta oss för att få tillgång till {category.label}</a>
                        </span>
                    );
                    
                }
            })}
        </>
    );
}

const CategoryNavigation = props => {
    return (
        <div className={classNames({
            'category-navigation': true,
            'category-navigation--is-loading': props.isLoading
        })}>
            <CategoryNavigationItems {...props} />
        </div>
    );
};

export default CategoryNavigation;